"use client";

import { useMemo, type ReactNode } from "react";
import { NextIntlClientProvider, useLocale, useMessages } from "next-intl";
import { mergeMessages, type MessageTree } from "@/lib/i18n-pick";

/**
 * Adds a route segment's messages to the ones the layers above it gave
 * (`LN-UI03`). The server sends each layer's own paths once
 * (`SegmentMessages`); this lays them over its parent's on the client, so a
 * page change inside a segment does not ship the layers above it again.
 */
export function MessagesLayer({ messages, children }: { messages: MessageTree; children: ReactNode }) {
  const parent = useMessages() as MessageTree;
  const locale = useLocale();
  const merged = useMemo(() => mergeMessages(parent, messages), [parent, messages]);
  return (
    <NextIntlClientProvider locale={locale} messages={merged}>
      {children}
    </NextIntlClientProvider>
  );
}
